import React, { useState, useCallback } from 'react';
import VehicleTab from './VehicleTab';
import './VehicleTabs.scss'
import { isMobile } from '../../helpers/helpers'
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import CONSTANTS from '../../Constants';

const VehicleTabs = (props) => {
    const vehicleInfo = useSelector((state => state.ndel_store.vehicleInfo))
    const [showTab, setShowTab] = useState(true)
    const defaultTabNumber = isMobile() ? '1' : '1'
    const ActivateTabImmat = (!!Number(CONSTANTS.SITE_CONFIG.ActivateTabImmat))
    const ActivateTabNumSerie = (!!Number(CONSTANTS.SITE_CONFIG.ActivateTabNumSerie))
    const [activeTab, setActiveTab] = useState(vehicleInfo.tabNumber || defaultTabNumber)
    const handlClickTabItem = useCallback((order, showTab) => {
        setShowTab(showTab)
        setActiveTab(order)
    }, [])
    useEffect(() => {
        if (!vehicleInfo.tabNumber) {
            if (ActivateTabNumSerie && !ActivateTabImmat) {
                setActiveTab('2')
            } else if (!ActivateTabNumSerie && !ActivateTabImmat) {
                setActiveTab('3')
            }
        }

    }, [])
    return (
        <div className="car-tabs">
            {!isMobile() && <>
                <ul className={`tab-list`}>
                    {
                        props.children.map((child) => {
                            // this is made to skip false element , when step is disabled in BO.
                            if (!child) {
                                return;
                            }
                            const { label, order } = child.props
                            return (
                                <VehicleTab
                                    activeTab={activeTab}
                                    order={order}
                                    label={label}
                                    onClick={handlClickTabItem}
                                    key={order}
                                />
                            );
                        })
                    }
                </ul>
                <div className="tab-content">

                    {
                        props.children.map((child) => {
                            // this is made to skip false element , when step is disabled in BO.
                            if (!child) {
                                return;
                            }
                            if (child.props.order !== activeTab) return undefined;
                            return child.props.children;
                        })
                    }
                </div>
            </>}
            {/* if Mobile put the content inside the tab to meet the requirement of XD Design*/}
            {isMobile() && <>
                <ul className="tab-list">

                    {props.children.map((child) => {
                        // this is made to skip false element , when step is disabled in BO.
                        if (!child) {
                            return;
                        }
                        const { label, order } = child.props;

                        return (
                            <>
                                <VehicleTab
                                    activeTab={activeTab}
                                    order={order}
                                    label={label}
                                    onClick={handlClickTabItem}
                                />
                                <div className="tab-content">
                                    {(child.props.order === activeTab) && showTab && props.children.map((child) => {
                                        if (!child) {
                                            return;
                                        }
                                        if (child.props.order !== activeTab) return undefined;
                                        return child.props.children;
                                    })}
                                </div>
                            </>
                        );

                    })}
                </ul>
            </>}
        </div>
    );

}

export default VehicleTabs;
